class CartSummary extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  async render() {
    const cart = await this.getCart();

    const container = this;
    const stickyBar = document.createElement("div");
    stickyBar.classList.add("sticky-bar", "cart-sticky-bar");
    stickyBar.innerHTML = `
    <div class="container">
      <div class="info-container">
        <div class="info-wrapper">
          <p class="title">Shipping Calculated At Checkout</p>
          <p class="subtitle">{{SUBTITLE}}</p>
        </div>
      </div>
      <div class="price-container">
        <div class="price-wrapper">
          <p class="estimated-total">Estimated Total</p>
          <p class="price">{{PRICE}}</p>
        </div>
        <button class="btn">Checkout</button>
      </div>
    </div>
    `;
    stickyBar.innerHTML = stickyBar.innerHTML.replace(
      "{{SUBTITLE}}",
      `${cart.item_count} ${cart.item_count > 1 ? "items" : "item"}`,
    );
    stickyBar.innerHTML = stickyBar.innerHTML.replace(
      "{{PRICE}}",
      theme.Currency.formatMoney(cart.total_price),
    );

    this.handleVisibility_Cart(cart);

    setInterval(() => {
      this.handleVisibility_Cart(cart);
    }, 1000);

    stickyBar.querySelector(".btn").addEventListener("click", function () {
      $("#cart-initiateCheckout").click();
    });

    container.append(stickyBar);

    this.handleChange_Cart();
  }

  async getCart() {
    return await (await fetch("/cart.js")).json();
  }

  handleVisibility_Cart(cartData) {
    const container = $(this);

    if (cartData.item_count > 0) {
      container.css("bottom", "");
      container.removeClass("hide");
    } else {
      container.css("bottom", `-${this.outerHeight()}px`);
      container.addClass("hide");
    }
  }

  updateCartSummary() {
    const container = $(this);
    const itemsCount = $(".cart-table tbody tr").length;

    if (itemsCount == 0) {
      container.hide();
      return;
    }

    container
      .find(".info-container .subtitle")
      .text(`${itemsCount} ${itemsCount > 1 ? "items" : "item"}`);

    let amount = $(".cart__footer [data-est-total]")
      .first()
      .attr("data-est-total");
    amount = Number(amount || 0);
    container
      .find(".price-container .price")
      .text(theme.Currency.formatMoney(amount));
  }

  handleChange_Cart() {
    // Select the node that will be observed for mutations
    const targetNode = document.querySelector("#MainContent");

    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = () => {
      this.updateCartSummary();
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    // Later, you can stop observing
    // observer.disconnect();
  }
}

customElements.define("cart-summary", CartSummary);
